import * as React from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import { useStore } from "stores/connect";
import { TelemetrySettingsStore, TelemetrySettingsActions } from "stores/telemetry/TelemetrySettingsStore";
import AppConfig from "util/AppConfig";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
const getPostHogSettings = () => {
  const { host, api_key: key } = AppConfig.telemetry() || {};
  return {
    host,
    key
  };
};
const init = (key, host) => {
  posthog.init(key, {
    autocapture: false,
    api_host: host,
    capture_pageview: false,
    capture_pageleave: false,
    cross_subdomain_cookie: false,
    persistence: "cookie"
  });
  return posthog;
};
const TelemetryInit = ({ children }) => {
  const settings = useStore(TelemetrySettingsStore, (state) => state.telemetrySetting);
  const { host, key } = getPostHogSettings();
  const { currentUser } = useStore(CurrentUserStore);
  useEffect(() => {
    if (currentUser) {
      TelemetrySettingsActions.get();
    }
  }, [currentUser]);
  if (!(settings == null ? void 0 : settings.telemetry_enabled) || !host || !key) {
    return children;
  }
  return /* @__PURE__ */ React.createElement(PostHogProvider, { client: init(key, host) }, children);
};
export default TelemetryInit;
